export function normalizeImageUrl(url: string | null | undefined): string {
  if (!url) return "/img/v2/casino/onError.webp"
  if (url.startsWith("//")) return `https:${url}`
  return url
}

export type GameThumbSources = {
  ai_thumb_url?: string | null
  thumb_url?: string | null
}

export function pickGameThumbUrl(sources: GameThumbSources, failedCount: number): string | null {
  const chain = [sources.ai_thumb_url, sources.thumb_url].filter((url): url is string => {
    return Boolean(url?.trim())
  })
  return chain[failedCount] ?? null
}
